import { computed } from 'vue'
import { createSharedComposable, useNow } from '@vueuse/core'

// Start of the current UTC day as a timestamp. The value changes once a day, so computeds that
// read it re-run only when a due date can flip. A minute tick also catches up after sleep.
export const useUtcToday = createSharedComposable(() => {
  const now = useNow({ interval: 60 * 1000 })
  return computed(() =>
    Date.UTC(now.value.getUTCFullYear(), now.value.getUTCMonth(), now.value.getUTCDate())
  )
})
